import styled from 'styled-components';

export const Container = styled.div`
  margin: auto;
  height: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Icon = styled.img`
  width: 160px;
`;
